module.exports = __webpack_public_path__ + "static/media/icn_top_equity_funds.b4905776.svg";